<template>
  <div class="wrapper">
    <Loader v-if="loader"></Loader>
          <v-form v-model="isValid" ref="form">
            <v-text-field
              solo
              v-model="amount"
              type="number"
              label="Amount"
              required
            />
            <v-radio-group  class="mt-0" row v-model="type">
              <v-radio label="IMPS" value="imps"></v-radio>
              <v-radio label="NEFT" value="neft"></v-radio>
            </v-radio-group>

          </v-form>
          <v-btn block depressed class="success" @click="submit()">Submit</v-btn>
  </div>
</template>

<script>
import Loader from "../components/Loader";
export default {
  components: { Loader },
  data() {
    return {
      isValid: false,
      loader: false,
      type: "imps",
      rule: [v => !!v || "Amount is required"],
      amount: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    security() {
      return this.$store.getters.security;
    }
  },
  methods: {
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    },
    submit() {
      const vm = this;
      let form = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Amount: vm.amount,	
        PaymentType: vm.type,
        Security_Key: vm.security
      };
      if(vm.amount == "") return vm.notification("error", " is required");
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Minks_Payout",
          type: "mink",
          data: form
        })
        .then(function(res) {
          vm.loader = false;
          if (res.data.Status === "true") {
            vm.$root.alert(res.data.Message)
            vm.amount = "";
            return;
          }
          vm.$root.alert(res.data.Message)

        })
        .catch(function(error) {
          vm.loader = false;
          vm.notification("error", error.message);
        });
    }
  }
};
</script>

<style scoped>
  .wrapper {
    width: 400px;
    margin:0 auto;
    margin-top: 30px;
  }
</style>